import { ImagingRound, SignalstarAntibody, TargetSpecies, BufferKitInterface } from '@cstweb/commercetools-client'
import { defineStore } from 'pinia'
import { HARDCODED_CUSTOM_CONDITIONS } from '~/common/static/signalstarConditions'

// SS-TODO: Rename type on ssSecurity Clean up
export type PanelBuilderConfigurationV2 = {
  lastUpdated?: number

  targetSpecies?: TargetSpecies
  selectedTargets?: SignalstarAntibody[]
  imagingRounds?: ImagingRound[]

  // .. After creation on step 4
  ctCustomObjectId?: string
  experimentId?: string
  url?: string | null
  bufferKit?: BufferKitInterface
}

const DEFAULT_STATE: PanelBuilderConfigurationV2 = {
  lastUpdated: undefined,
  targetSpecies: undefined,
  selectedTargets: undefined,
  imagingRounds: undefined,
  ctCustomObjectId: undefined,
  experimentId: undefined,
  bufferKit: undefined,
  url: undefined,
} as const

const STORE_ID = 'panelBuilderConfigurationStore'

export const usePanelbuilderConf = defineStore({
  id: STORE_ID,
  state: (): PanelBuilderConfigurationV2 => DEFAULT_STATE,
  getters: {
    getConfiguration(): PanelBuilderConfigurationV2 {
      return {
        targetSpecies: this.targetSpecies,
        selectedTargets: this.selectedTargets,
        imagingRounds: this.imagingRounds,
        ctCustomObjectId: this.ctCustomObjectId,
        experimentId: this.experimentId,
        bufferKit: this.bufferKit,
        url: this.url,
      }
    },
  },
  actions: {
    updateStore(conf: Partial<PanelBuilderConfigurationV2>) {
      this.$patch({
        ...conf,
        lastUpdated: Date.now(),
      })
    },
    resetConfiguration() {
      this.$reset()
    },

    // ..
    setTargetSpecies(targetSpecies: TargetSpecies) {
      this.updateStore({
        ...DEFAULT_STATE,
        targetSpecies,
      })
    },
    setSelectedTargets(selectedTargets: SignalstarAntibody[]) {
      this.updateStore({
        ...this.$state,
        imagingRounds: undefined,
        selectedTargets: selectedTargets.map((target) => ({
          ...target,
          types: target.types.map((type) => ({
            ...type,
            // .. TEMPORARY: mimic conditions being part of product in commerce tools
            customConditions: type.productNumber
              ? HARDCODED_CUSTOM_CONDITIONS[type.productNumber] ?? undefined
              : undefined,
          })),
        })),
      })
    },
    setImagingRounds(imagingRounds: ImagingRound[]) {
      this.updateStore({
        ...this.$state,
        imagingRounds,
      })
    },
  },
  persist: {
    beforeRestore: () => {
      const storageJson = localStorage.getItem(STORE_ID)
      const oneDay = 60 * 60 * 1000

      if (storageJson) {
        const lastUpdated = JSON.parse(storageJson).lastUpdated
        const now = Date.now()

        // .. Resetting local storage if it is expired
        if (lastUpdated && now - lastUpdated > oneDay) {
          localStorage.removeItem(STORE_ID)
          console.log('Panel builder configuration has expired!')
        }
      }
    },
  },
})
